import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Row, Col, Card, CardBody, Table, Button, Input, Label, Form, FormGroup, Nav, NavItem, NavLink, TabContent, TabPane, Alert, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { connect } from 'react-redux';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, ContentState } from 'draft-js';
import 'draft-js/dist/Draft.css';

import { stateFromHTML } from 'draft-js-import-html';

import htmlToDraft from 'html-to-draftjs';

import {
  getResourceCentreTopLinks,
} from '../../../../actions/resourceCenter';

class TopLinks extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    admin: PropTypes.shape(),
    fetchResourceCentre: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    admin: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      editorState: EditorState.createEmpty(),
    };
  }

  componentDidMount() {
    const { fetchResourceCentreTopLinks, admin, user, isLoggedIn, history } = this.props;

    fetchResourceCentreTopLinks().then((res) => {
      if (res.payload) {
        const blocksFromHtml = htmlToDraft(res.payload);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);

        if (contentState) {
          this.setState({ editorState: EditorState.createWithContent(contentState) });
        }
      }
    });
  }

  render() {
    const { editorState } = this.state;

    return (
      <div>
        <Row>
          <Col xs="12">
              <Editor
                className="content-management-text-area"
                editorState={editorState}
                toolbarHidden
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName"
                readOnly
              />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  videos: state.resourceCenter.videos || [],
});

const mapDispatchToProps = {
  fetchResourceCentreTopLinks: getResourceCentreTopLinks,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopLinks));

// export default Dashboard;
